import React from 'react';
import {
  AppBar, Toolbar, Typography, IconButton, Box, Badge, Tooltip, Menu, MenuItem, Avatar, Divider
} from '@mui/material';
import { Notifications, Settings, Menu as MenuIcon, Refresh, ExitToApp } from '@mui/icons-material';
import { alpha, useTheme } from '@mui/material/styles';
import { useAuth } from '../../hooks/useAuth';

interface NavbarProps {
  onMenuToggle: () => void;
  title: string;
}

const Navbar: React.FC<NavbarProps> = ({ onMenuToggle, title }) => {
  const { user, logout, isAdmin } = useAuth();
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  return (
    <AppBar position="fixed" sx={{ zIndex: (t) => t.zIndex.drawer + 1 }}>
      <Toolbar sx={{ gap: 1 }}>
        <IconButton onClick={onMenuToggle} sx={{ color: 'text.primary' }}>
          <MenuIcon />
        </IconButton>

        <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.primary', letterSpacing: '-0.01em', flexGrow: 1 }}>
          {title}
        </Typography>

        <Box display="flex" alignItems="center" gap={0.5}>
          <Tooltip title="Aggiorna">
            <IconButton size="small" onClick={() => window.location.reload()}
              sx={{ color: 'text.secondary', '&:hover': { color: 'text.primary', '& .MuiSvgIcon-root': { transform: 'rotate(180deg)' } }, '& .MuiSvgIcon-root': { transition: 'transform 300ms ease' } }}>
              <Refresh sx={{ fontSize: 20 }} />
            </IconButton>
          </Tooltip>

          <Tooltip title="Notifiche">
            <IconButton size="small" sx={{ color: 'text.secondary' }}>
              <Badge variant="dot" color="error" sx={{ '& .MuiBadge-dot': { width: 8, height: 8, borderRadius: 4, border: `2px solid ${isDark ? '#0B0F1A' : '#F8FAFC'}` } }}>
                <Notifications sx={{ fontSize: 20 }} />
              </Badge>
            </IconButton>
          </Tooltip>

          <Tooltip title="Impostazioni">
            <IconButton size="small" sx={{ color: 'text.secondary' }}>
              <Settings sx={{ fontSize: 20 }} />
            </IconButton>
          </Tooltip>

          {user && (
            <>
              <IconButton onClick={(e) => setAnchorEl(e.currentTarget)} sx={{ ml: 0.5, p: 0.5 }}>
                <Avatar sx={{ width: 32, height: 32, fontSize: '0.875rem', fontWeight: 600, background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`, border: `2px solid ${alpha(theme.palette.primary.main, 0.3)}` }}>
                  {user.username.charAt(0).toUpperCase()}
                </Avatar>
              </IconButton>
              <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }} anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                PaperProps={{ sx: { mt: 1, minWidth: 180 } }}>
                <Box sx={{ px: 2, py: 1 }}>
                  <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>{user.username}</Typography>
                  <Typography variant="caption" color="text.secondary">{isAdmin() ? 'admin' : 'user'}</Typography>
                </Box>
                <Divider />
                <MenuItem onClick={() => { setAnchorEl(null); logout(); }} sx={{ color: 'error.main' }}>
                  <ExitToApp sx={{ fontSize: 18, mr: 1.5 }} />
                  <Typography variant="body2">Esci</Typography>
                </MenuItem>
              </Menu>
            </>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
